import React from "react";
import { DatePicker, Input, Select, Tooltip } from "antd";
import dayjs from "dayjs";

import { ComponentInput, ComponentLine } from "../../styled";
import { CiImport } from "react-icons/ci";

export default function OptionDadosDaEmpresa({
  dadosCliente,
  statusInput,
  setstatusInput,
  setdadosCliente,
  onChangeSelectSegmentoEmpresa,
  escolherRegimeTributario,
  isDataOpcaoSN,
  TruckOutlined,
  isMostrarCamposCasoSegmentoAtualForDiferenteDePS,
  onChangeSelectContribuicaoEstadual,
  isCampoIE,
  isCampoSituacaoIE,
  getSituacaoPlaceholder,
  escolherSituacaoIE,
  setModalUploadDoc
}) {
  return (
    <>
      <ComponentLine>
        <ComponentInput>
          <p>Tipo de Empresa</p>
          <Select
            placeholder={"Selecione"}
            value={dadosCliente.tipoEmpresa}
            style={{ width: 240 }}
            status={statusInput === "tipoEmpresa" ? "error" : ""}
            onChange={(value) => {
              setstatusInput(value === "" ? "error" : "");

              setdadosCliente((prevState) => ({
                ...prevState,
                tipoEmpresa: value,
              }));
            }}
            options={[
              { value: 'MEI', label: 'MEI - Microempreendedor Individual' },
                                                { value: 'EI', label: 'EI - Empresário Individual' },
                                                { value: 'LTDA', label: 'LTDA - Empresa de Sociedade Limitada' },
                                                { value: 'SA', label: 'SA - Sociedade Anônima' },
                                                { value: 'PA', label: 'PA - Profissional Autônomo' },

                                                { value: 'S/S', label: 'S/S - Sociedade Simples' },
                                                { value: '3220', label: '3220 - Organizações Religiosas' },
                                                { value: '3990', label: '3990 - Associações Privadas' },
              {
                value: "Selecione",
                label: "Selecione",
                disabled: true,
              },
            ]}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Enquadramento</p>
          <Select
            placeholder={
              dadosCliente.enquadramento === null ||
              dadosCliente.enquadramento === ""
                ? "Selecione"
                : dadosCliente.enquadramento
            }
            value={dadosCliente.enquadramento}
            status={statusInput === "enquadramento" ? "error" : ""}
            onChange={(value) => {
              setstatusInput(value === "" ? "error" : "");

              setdadosCliente((prevState) => ({
                ...prevState,
                enquadramento: value, // Atualiza o tipo de empresa com o valor selecionado
              }));
            }}
            style={{ width: 240 }}
            options={[
              {
                value: "MEI",
                label: "MEI MicroEmpreendedor Individual",
              },
              { value: "ME", label: "ME - MicroEmpresa" },
              {
                value: "EPP",
                label: "EPP Empresa de Pequeno Porte",
              },
              { value: "Normal", label: "Normal" },
              { value: "PA", label: "PA - Prrofissional Autônomo" },
              { value: "PL", label: "PL - Prrofissional Liberal" },
              {
                value: "Selecione",
                label: "Selecione",
                disabled: true,
              },
            ]}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Segmento Atuação</p>
          <Select
            placeholder={
              dadosCliente.segmentoAtuacao === null ||
              dadosCliente.segmentoAtuacao === ""
                ? "Selecione"
                : dadosCliente.segmentoAtuacao
            }
            value={dadosCliente.segmentoAtuacao}
            status={statusInput === "segmentoAtuacao" ? "error" : ""}
            onChange={onChangeSelectSegmentoEmpresa}
            style={{ width: 240 }}
            options={[
              {
                value: "PS",
                label: "PS - Empresa Prestadora de Serviços",
              },
              {
                value: "PSC",
                label: "PSC - Empresa Prestadora de Serviços e Comércio",
              },
              {
                value: "PSI",
                label: "PSI - Empresa Prestadora de Serviços e Indústria",
              },
              {
                value: "PSCI",
                label: "Empresa Prestadora de Serviços, Comércio e Indústria",
              },
              { value: "C", label: "C - Comércio" },
              { value: "I", label: "I - Indústria" },
              { value: "CI", label: "CI - Comércio e Indústria" },
              {
                value: "Selecione",
                label: "Selecione",
                disabled: true,
              },
            ]}
          />
        </ComponentInput>
      </ComponentLine>

      <ComponentLine>
        <ComponentInput>
          <p>Regime Tributário</p>
          <Select
            placeholder="Selecione"
            value={dadosCliente.regimeTributario}
            status={statusInput === "regimeTributario" ? "error" : ""}
            onChange={escolherRegimeTributario}
            style={{ width: 240 }}
            options={[
              {
                value: "SIMEI",
                label: "SIMEI - Sistema de Recolhimento MEI",
              },
              { value: "SN", label: "SN - Simples Nacional" },
              { value: "LP", label: "LP - Lucro Presumido" },
              { value: "LR", label: "LR - Lucro Real" },
              {
                value: "Selecione",
                label: "Selecione",
                disabled: true,
              },
            ]}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Data Análise Simples Nacional</p>
          <DatePicker
            style={{ width: 240 }}
            className="date-picker"
            format="DD/MM/YYYY"
            value={
              dadosCliente.dataPedidoSN
                ? dayjs(dadosCliente.dataPedidoSN)
                : null
            } // Certifique-se de passar um objeto dayjs
            status={statusInput === "dataPedidoSN" ? "error" : ""}
            onChange={(date) => {
              setstatusInput(date === "" ? "error" : "");
              setdadosCliente((prevState) => ({
                ...prevState,
                dataPedidoSN: date ? date.toISOString() : null, // Atualize a data em formato ISO
              }));
            }}
          />
        </ComponentInput>

        {isDataOpcaoSN && (
          <ComponentInput>
            <p>Data Opção Simples Nacional</p>
            <DatePicker
              style={{ width: 240 }}
              className="date-picker"
              value={
                dadosCliente.dataOpcaoSN
                  ? dayjs(dadosCliente.dataOpcaoSN)
                  : null
              } // Certifique-se de passar um objeto dayjs
              onChange={(date) =>
                setdadosCliente((prevState) => ({
                  ...prevState,
                  dataOpcaoSN: date ? date.toISOString() : null, // Atualize a data em formato ISO
                }))
              }
              format="DD/MM/YYYY"
              disabled={TruckOutlined}
            />
          </ComponentInput>
        )}
      </ComponentLine>

      <ComponentLine>
        <ComponentInput>
          <p>NIRE/Cartório</p>
          <Input
            style={{ width: 240 }}
            placeholder={
              dadosCliente.nire === null || dadosCliente.nire === ""
                ? "NIRE/Cartório"
                : dadosCliente.nire
            }
            value={dadosCliente.nire}
            status={statusInput === "nire" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;

              setstatusInput(value === "" ? "error" : "");

              setdadosCliente((prevState) => ({
                ...prevState,
                nire: value,
              }));
            }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>IM</p>
          <Input
            placeholder={
              dadosCliente.im === null || dadosCliente.im === ""
                ? "IM"
                : dadosCliente.im
            }
            value={dadosCliente.im}
            status={statusInput === "im" ? "error" : ""}
            onChange={(e) => {
              const value = e.target.value;

              // Resetar o status para "" quando o usuário começar a digitar
              setstatusInput(value === "" ? "error" : "");

              setdadosCliente((prevState) => ({
                ...prevState,
                im: value,
              }));
            }}
            style={{ width: 240 }}
          />
        </ComponentInput>

        <ComponentInput>
          <p>Forma de Atuação</p>
          <Select
            placeholder="Selecione"
            value={dadosCliente.formaAtuacao}
            status={statusInput === "formaAtuacao" ? "error" : ""}
            onChange={(value) => {
              setstatusInput(value === "" ? "error" : "");

              setdadosCliente((prevState) => ({
                ...prevState,
                formaAtuacao: value,
              }));
            }}
            style={{ width: 240 }}
            options={[
              {
                value: "E",
                label: "Estabelecida",
              },
              {
                value: "NE",
                label: "Não Estabelecido",
              },
              {
                value: "Selecione",
                label: "Selecione",
                disabled: true,
              },
            ]}
          />
        </ComponentInput>
      </ComponentLine>

        <>
          <ComponentLine>
            <ComponentInput>
              <p>Contribuição Estadual (ICMS)</p>
              <Select
                placeholder={
                  dadosCliente.contribuicaoIe === "I"
                    ? "Isento"
                    : dadosCliente.contribuicaoIe ||
                      dadosCliente.contribuicaoIe === "C"
                    ? "Contribuinte"
                    : dadosCliente.contribuicaoIe ||
                      dadosCliente.contribuicaoIe === "N"
                    ? "Não Contribuinte"
                    : dadosCliente.contribuicaoIe
                }
                value={dadosCliente.contribuicaoIe}
                onChange={onChangeSelectContribuicaoEstadual}
                style={{ width: 240 }}
                options={[
                  {
                    value: "C",
                    label: "Contribuinte",
                  },
                  {
                    value: "N",
                    label: "Não Contribuinte",
                  },
                  {
                    value: "I",
                    label: "Isento",
                  },
                  {
                    value: "Selecione",
                    label: "Selecione",
                    disabled: true,
                  },
                ]}
              />
            </ComponentInput>

            {isCampoIE && (
              <ComponentInput>
                <p>IE</p>
                <Input
                  style={{ width: 240 }}
                  placeholder={
                    dadosCliente.contribuicaoIe === "N"
                      ? "NAO CONTRUINTE"
                      : "IE"
                  }
                  disabled={dadosCliente.contribuicaoIe !== "C" ? true : false}
                  value={dadosCliente.ie}
                  status={statusInput === "ie" ? "error" : ""}
                  onChange={(e) => {
                    const value = e.target.value;

                    // Resetar o status para "" quando o usuário começar a digitar
                    setstatusInput(value === "" ? "error" : "");
                    setdadosCliente((prevState) => ({
                      ...prevState,
                      ie: value,
                    }));
                  }}
                />
              </ComponentInput>
            )}
            {isCampoSituacaoIE && (
              <ComponentInput>
                <p>Situação IE</p>
                <Select
                  placeholder={getSituacaoPlaceholder(dadosCliente.situacaoIe)}
                  value={dadosCliente.situacaoIe}
                  onChange={escolherSituacaoIE}
                  style={{ width: 240 }}
                  options={[
                    {
                      value: "A",
                      label: "Ativa",
                    },
                    {
                      value: "I",
                      label: "Inativa",
                    },
                    {
                      value: "S",
                      label: "Suspensa",
                    },
                    {
                      value: "IN",
                      label: "Inapta",
                    },
                    {
                      value: "Selecione",
                      label: "Selecione",
                      disabled: true,
                    },
                  ]}
                />
              </ComponentInput>
            )}
          </ComponentLine>
        </>
     
    </>
  );
}
